import { useCallback, useState } from "react";
import { fetchVideos } from "../api";
import { groupVideoRows } from "../utils/parsers";
import useDebouncedLoad from "./useDebouncedLoad";

// The day list under the processing grid: every video registered on `date`
// (today when null) grouped per file. Reloads on `refreshKey` changes
// (socket refreshes, debounced) and at once on reload().
// status: "idle" | "loading" | "ready" | "error"
export default function useVideoList(enabled, date, refreshKey = 0) {
  const [groups, setGroups] = useState([]);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);
  const [version, setVersion] = useState(0);

  const reload = useCallback(() => setVersion((v) => v + 1), []);

  useDebouncedLoad(enabled, refreshKey, [date, version], (isCancelled) => {
    setStatus((current) => (current === "ready" ? current : "loading"));
    fetchVideos(date)
      .then((data) => {
        if (isCancelled()) return;
        setGroups(groupVideoRows(data?.videos));
        setError(null);
        setStatus("ready");
      })
      .catch((err) => {
        if (isCancelled()) return;
        setStatus("error");
        setError(err?.message || "Request failed");
      });
  });

  return { groups, status, error, reload };
}
